import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from 'api/Api';

export interface ChatHistoryModelItem {
  sender: 'model';
  message: {
    id: string;
    kind: 'main' | 'followup' | 'final';
    question: string;
    answer_type: 'choice_strict' | 'choice_allow_other' | 'text';
    options?: {
      label: string;
    }[];
    followup_for?: string;
    end?: boolean;
  };
  createdAt: Date;
}

export interface ChatHistoryUserItem {
  sender: 'user';
  message: string;
  createdAt: Date;
}

export interface FlowCommunicateResponse {
  chatItem: ChatHistoryModelItem;
  currentState: ChatCurrentState;
}

export interface ChatCurrentState {
  answers: {
    recipientId?: string;
    recipientName?: string;
    recipientRelationship?: string;
    occasion?: string;
    tone?: string;
    extra?: string;
  };
}

export const flowAiApi = createApi({
  baseQuery: baseQueryWithReAuth,
  reducerPath: 'flowAiApi',
  endpoints: (build) => ({
    createFlow: build.mutation<{ id: string }, void>({
      query: () => ({
        url: '/message/ai/flow',
        method: 'POST'
      }),
      transformResponse: (response: { data: { id: string } }) => response.data
    }),
    loadFlowHistory: build.query<any[], { id: string }>({
      query: ({ id }) => ({
        url: `/message/ai/flow/${id}/history`
      }),
      transformResponse: (response: { data: (ChatHistoryModelItem | ChatHistoryUserItem)[] }) => response.data,
      keepUnusedDataFor: 0
    }),
    communicateFlow: build.mutation<FlowCommunicateResponse, { id: string; questionId: string; answer: string }>({
      query: ({ id, ...body }) => ({
        url: `/message/ai/flow/${id}/communicate`,
        method: 'POST',
        body
      }),
      transformResponse: (response: { data: FlowCommunicateResponse }) => response.data
    })
  })
});

export const { useCreateFlowMutation, useLoadFlowHistoryQuery, useCommunicateFlowMutation } = flowAiApi;
